import styled from "@emotion/styled"
import { PInputText } from "@porsche-design-system/components-react"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { useState } from "react"
import { HexColorPicker } from "react-colorful"
import { useController, useFormContext } from "react-hook-form"
import { defineMessages, useIntl } from "react-intl"
import { ExteriorColorTile } from "src/components/exteriorColorTile"

const messages = defineMessages({
	invalidHexCode: {
		defaultMessage: "Invalid hex code for color",
		id: "colors.validation.hexCodeInvalid",
	},
})

export interface ColorPickerFieldProps {
	disabledHint?: string
	glossy?: boolean
	label: string
	name: string
	readOnly?: boolean
	required?: boolean
}

export const ColorPickerField = ({ disabledHint, glossy, label, name, readOnly, required }: ColorPickerFieldProps) => {
	const { formatMessage } = useIntl()

	const { control } = useFormContext()
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name,
		rules: {
			pattern: {
				message: formatMessage(messages.invalidHexCode),
				value: /#[0-9a-fA-F]{6}/,
			},
			required,
		},
	})

	const [isColorPickerOpen, setIsColorPickerOpen] = useState(false)

	return (
		<div>
			<Centered>
				<ThreeQuartersWidth>
					<PInputText
						{...field}
						label={label}
						state={error ? "error" : undefined}
						message={error?.message}
						required={!!required}
						disabled={!!disabledHint}
						readOnly={readOnly}
						onClick={() => setIsColorPickerOpen(true)}
						autoComplete="off"
					/>
				</ThreeQuartersWidth>
				{field.value && (
					// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					<div onClick={() => !disabledHint && !readOnly && setIsColorPickerOpen(true)}>
						<ExteriorColorTile color={field.value} glossy={!!glossy} />
					</div>
				)}
			</Centered>
			{isColorPickerOpen && !readOnly && (
				<Popover>
					<WholePageCover onClick={() => setIsColorPickerOpen(false)} />
					<HexColorPicker onChange={field.onChange} color={field.value} />
				</Popover>
			)}
		</div>
	)
}

const Popover = styled.div`
	position: absolute;
	z-index: 2;
`

const WholePageCover = styled.div`
	position: fixed;
	inset: 0;
`

const Centered = styled.div`
	display: flex;
	align-items: center;
	gap: ${spacingStaticSm};
`

const ThreeQuartersWidth = styled.div`
	width: 75%;
`
